import { RADIO_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";
import { INVOICE_TYPES } from "@utils/Constants";

export const CABYS_TEXT_FILTER_CODE = "1";
export const CABYS_CODIGO_FILTER_CODE = "2";

const SearchIdentificacionForm = {
    submit: {
        label: "Buscar"
    },
    sections: [
        {
            "fields": [
                [
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "tipoFiltro",
                        "validation": Yup.string().required(),
                        "label": "Tipo Busqueda",
                        "isHorizontalValues": true,
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 6
                            }
                        },
                        "options": {
                            [CABYS_TEXT_FILTER_CODE]: "Por Nombre",
                            [CABYS_CODIGO_FILTER_CODE]: "Por Codigo",
                        },
                        "defaultValue": "1",
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "filtro",
                        // "isHorizontal": true,
                        "label": "Filtro",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 6
                            }
                        }
                    },
                ]
            ]
        }
    ],
};


export default SearchIdentificacionForm;